// extracted by mini-css-extract-plugin
export default {"cursorLabel":"Cursor_cursorLabel__X7M1j","cursorLine":"Cursor_cursorLine__IitcP","daySeparator":"Cursor_daySeparator__PFTAH","outSidePublication":"Cursor_outSidePublication__5waGx"};